
//アンカーリンク用
// var SmoothScroll = require('./functions/smoothscroll.js');
//画面幅・高さに合わせて各種調整用
// var HeightVisual = require('./functions/heightVisual.js');
//最も高い要素に合わせる用
// var AdjustHeight = require('./functions/adjustHeight.js');
//Topへ戻るボタン
var ScrollTop = require('./functions/scrollTop.js');
//スクロールフェード
var ScrollFade = require('./functions/scrollFade.js');
// var CookieController = require('./functions/cookieController.js');
// var DateController = require('./functions/dateController.js');
// console.log('first');
$(document).on('ready', function(){
    // SmoothScroll.init("",null);
    if ($(".js-modal-video").length) { //クラス名js-modal-videoがあれば以下を実行
        $(".js-modal-video").modalVideo({
            channel: "youtube",
            youtube: {
            rel: 0, //関連動画の指定
            autoplay: 1, //自動再生の指定
            controls: 1, //コントロールさせるかどうかの指定
            mute: 0,
            }
        });
    }
    //TOPへ戻る
    ScrollTop.init("","#fn-topButton");


    if($(window).width() >= 1024 && $(window).width() <= 1286) {
        mvImageWidthAdjust($(window).width());
        mvBottomMarginAdjust($(window).width());
    }
    
    if($(window).width() <= 1024) {
        mvBottomMarginAdjust_none();
    }
    $(window).resize(function(e){
        var ww = e.target.innerWidth;
        if(ww >= 1024 && ww <= 1286) {
            mvImageWidthAdjust(ww);
            mvBottomMarginAdjust(ww);
        }
        if(ww <= 1024) {
            mvImageWidthAdjust_none();
            mvBottomMarginAdjust_none();
        }
        console.log(e.target.innerWidth);
    })
    function mvImageWidthAdjust(innerWidth) {
        var windowDistanceMax = 1286 - 1024;
        var imageDistanceW = 421 - 280;
        var windowDistance = 1286 - innerWidth;
        var mag = windowDistance / windowDistanceMax;
        $(".fn-adjustWidth").css({width:(421 - imageDistanceW*mag)+"px"});//421 280
    }
    function mvBottomMarginAdjust(innerWidth) {
        var windowDistanceMax = 1286 - 1024;
        var marginDistanceML = 137 - 56;
        var windowDistance = 1286 - innerWidth;
        var mag = 1 - windowDistance / windowDistanceMax;
        $(".fn_m-mainVisual__margin").css({"margin-left":(137 - marginDistanceML*mag)+"px"});//421 280
    }
    function mvImageWidthAdjust_none() {
        // $(".fn_m-mainVisual__margin").css({"margin-left":"initial"});
        $(".fn-adjustWidth").removeAttr("style");
    }
    function mvBottomMarginAdjust_none() {
        // $(".fn_m-mainVisual__margin").css({"margin-left":"initial"});
        $(".fn_m-mainVisual__margin").removeAttr("style");
    }

    //フロートボタンの表示非表示
    var observer = new IntersectionObserver(function(entries) {
        for(var e of entries) {
            if(e.isIntersecting) {   
                $("#fn-floatButton").fadeOut().removeClass("fn-on");
            } else {     
                $("#fn-floatButton").fadeIn().addClass("fn-on");
            }
        }
    });
    observer.observe(document.getElementById('fn-button'))



    //to top
    // var $buttonBox_header = $(".fn-buttonBox-header");
    // var $buttonBox_fixed = $(".fn-buttonBox-fixed");
    // var $buttonBox_footer = $(".fn-buttonBox-footer");
    // var $buttonBox_header_in = $(".fn-buttonBox-header .m-buttonBox");
    // var $buttonBox_fixed_in = $(".fn-buttonBox-fixed .m-buttonBox");
    // var $buttonBox_footer_in = $(".fn-buttonBox-footer .m-buttonBox");
    // var $buttonBox_header_height_half = $buttonBox_header_in.find("li").height() / 2;
    // var beforeFixedTop = 0;
    // var beforeType = null;
    // function setButtonBox() {console.log($buttonBox_header.offset().top+"/"+$buttonBox_fixed.offset().top+"/"+$buttonBox_footer.offset().top);
    //     if($buttonBox_footer.offset().top <= $buttonBox_fixed.offset().top ) {console.log("A");
    //         if(beforeType != null && )
    //         $buttonBox_fixed_in.removeClass("fn-show-fixed").removeClass("fn-show");
    //         $buttonBox_footer_in.removeClass("fn-hide");
    //         $buttonBox_header_in.addClass("fn-hide");
    //     //FooterからFixedを表示する時
    //     }else if(($buttonBox_header.offset().top + $buttonBox_header_height_half) <= $(window).scrollTop() && ($buttonBox_footer.offset().top) <= beforeFixedTop) {
    //         console.log("B");
    //         $buttonBox_fixed_in.addClass("fn-show");
    //         $buttonBox_header_in.addClass("fn-hide");
    //         $buttonBox_footer_in.addClass("fn-hide");
    //     }else if(($buttonBox_header.offset().top + $buttonBox_header_height_half) <= $(window).scrollTop()) {
    //         console.log("C");
    //         $buttonBox_fixed_in.addClass("fn-show-fixed");
    //         $buttonBox_header_in.addClass("fn-hide");
    //         $buttonBox_footer_in.addClass("fn-hide");
    //     }else if(($buttonBox_header.offset().top + $buttonBox_header_height_half) > $(window).scrollTop()) {
    //         console.log("D");
    //         $buttonBox_fixed_in.removeClass("fn-show-fixed").removeClass("fn-show");
    //         $buttonBox_header_in.removeClass("fn-hide");
    //         $buttonBox_footer_in.addClass("fn-hide");
    //     }else {
    //         console.log("E");
    //         $buttonBox_fixed_in.addClass("fn-show-fixed");
    //         $buttonBox_header_in.addClass("fn-hide");
    //         $buttonBox_footer_in.addClass("fn-hide");
    //     }
    // }
    // $(window).on("load", function(){
    //     beforeFixedTop = $buttonBox_fixed.offset().top
    //     setButtonBox();
    // });
    // $(window).on("scroll", function()
    // {
    //     setButtonBox();
    //     beforeFixedTop = $buttonBox_fixed.offset().top
    // });

    // var testCustom01 = function(elem){console.log("kiteru");
    //     var elemP = elem;
    //     elemP.find(".fn-fadeCustom-info01-01").addClass("fn-active");
    //     setTimeout(function(){elemP.find(".fn-fadeCustom-info01-02").addClass("fn-active")},400);
    //     setTimeout(function(){elemP.find(".fn-fadeCustom-info01-03").addClass("fn-active")},800);
    //     setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    // }
    // var animTopVisual = new ScrollFade({
    //     type:"fadeVisible",
    //     before_class:"fn-fade-to-up",
    //     after_class:"fn-fade-active"
    // });
    // var animMv01 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-mv",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-mv-01").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-mv-02").addClass("fn-active")},400);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-mv-03").addClass("fn-active")},800);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-mv-04").addClass("fn-active")},1200);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animInfo01 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-info01",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-info01-02").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info01-03").addClass("fn-active")},400);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},800);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animInfo02 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-info02",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-info02-02").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info02-03").addClass("fn-active")},400);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info02-04").addClass("fn-active")},800);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info02-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animInfo03 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-info03",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-info03-02").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info03-03").addClass("fn-active")},400);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info03-04").addClass("fn-active")},800);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info03-05").addClass("fn-active")},1200);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-info03-06").addClass("fn-active")},1600);
    //     }
    // });
    // var animFigure01 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-figure01",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-figure01-01").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure01-02").addClass("fn-active")},400);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure01-03").addClass("fn-active")},800);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animFigure02 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-figure02",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-figure02-01").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure02-02").addClass("fn-active")},800);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-figure02-03").addClass("fn-active")},800);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animFigure03 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-figure03",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-figure03-02").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure03-04").addClass("fn-active")},800);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure03-01").addClass("fn-active")},1200);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animFigure04 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-figure04",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-figure04-01").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure04-02").addClass("fn-active")},800);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure04-03").addClass("fn-active")},1200);
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure04-04").addClass("fn-active")},1600);
    //         // setTimeout(function(){elemP.find(".fn-fadeCustom-info01-04").addClass("fn-active")},1200);
    //     }
    // });
    // var animFigure04 = new ScrollFade({
    //     type:"fadeCustom",
    //     before_class:"fn-fadeCustom-figure05",
    //     func: function(elem){
    //         var elemP = elem;
    //         elemP.find(".fn-fadeCustom-figure05-01").addClass("fn-active");
    //         setTimeout(function(){elemP.find(".fn-fadeCustom-figure05-02").addClass("fn-active")},800);
    //     }
    // });

});

    